import './form.css';

/**
 * De schrijfregel, met de omzetting erbij.
 *
 * Een regel alleen werkte niet. "Schrijf over het pand, niet over de persoon"
 * klinkt duidelijk tot je met een telefoon in je hand voor een deur staat en
 * moet bedenken aan welke kant van die streep jouw zin valt.
 *
 * Het voorbeeldpaar doet wat de regel niet kan: het laat zien dat het niet om
 * mínder opschrijven gaat, maar om anders. Beide zinnen hieronder dragen
 * dezelfde bruikbare informatie — dat de kosten in de weg zitten. De
 * afgekeurde versie voegt daar een oordeel over de bewoner aan toe, en dat is
 * precies het stuk dat niemand nodig heeft en dat de bewoner mag opvragen.
 *
 * Ze komen alle twee uit de echte registraties.
 *
 * Bewust één paar en geen lijstje. Deze tip staat onder drie velden; een blok
 * van tien regels wordt daar behang. De volledige versie met meer voorbeelden
 * staat in docs/Schrijfwijzer-voor-afkoppelcoaches.md.
 */
export function Schrijftip(): JSX.Element {
  // Alles span: dit blokje hangt in de hint van een veld, en dat is zelf een
  // span. Een div of p daarbinnen is ongeldige opmaak.
  return (
    <span className="schrijftip">
      <span className="schrijftip__regel">
        <strong>Schrijftip</strong> — schrijf over het pand, niet over de persoon.
      </span>
      <span className="schrijftip__voorbeeld schrijftip__voorbeeld--wel">
        <span className="schrijftip__teken" aria-hidden="true">✓</span>
        Kosten en uitvoering zijn een drempel.
      </span>
      <span className="schrijftip__voorbeeld schrijftip__voorbeeld--niet">
        <span className="schrijftip__teken" aria-hidden="true">✗</span>
        Ziet op tegen de kosten, zeer onzeker dat ze meedoen.
      </span>
    </span>
  );
}
